module.exports = __webpack_public_path__ + "static/media/logo-esperantinopolis.75cd46b5.png";